var table_viewer_default = {
  "viewMode": "_35Q60",
  "editMode": "hpUyA",
  "container": "WzFEw",
  "cell": "RU4FA"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
